package nl.volleyplanner.api.client.planner

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import nl.volleyplanner.api.GeneratePageTokenRequest
import nl.volleyplanner.api.PageTokenDetails

class PageTokensClientEndpoint(val httpClient: HttpClient, prefix: String) {
    val base = "$prefix/token"

    suspend fun listTokens(tokenType: String) =
        httpClient.get("$base/$tokenType/list").body<List<PageTokenDetails>>()

    suspend fun generateToken(req: GeneratePageTokenRequest) =
        httpClient.post("$base/${req.pageType}/generate") {
            contentType(ContentType.Application.Json)
            setBody(req)
        }.body<PageTokenDetails>()
}